import { observable, action } from "mobx";
import api from "../lib/api";

class AppStore {
  @observable
  stack_id = null;

  @observable
  api_key = null;

  @observable
  app_data = {};

  @observable
  agentCardsChanged = false;

  @observable
  newOrder = [];

  @action
  setStack(stack_id) {
    this.stack_id = stack_id;
  }

  @action
  setAPIKey(key) {
    this.api_key = key;
  }

  @action logo() {
    if (this.app_data.theme) {
      return this.app_data.theme.logo;
    }
    return null;
  }

  @action setAppData(data) {
    this.app_data = data;
  }

  @action getAppData(stack_id, _callback) {
    api.getApp(
      stack_id,
      response => {
        this.app_data = response;
        _callback(true);
      },
      error => {
        _callback(false);
        // Do something drastic here!
      }
    );
  }
}

export default new AppStore();
